import { idtype } from "querypieces";

export default `
    ${idtype}
    heading
    subheading
`;